import React, {useEffect} from "react";
import {useScrollTop} from "../hooks";
import {useAppDispatch, useAppSelector} from "../app/hooks";
import {fetchProfileData} from "../features/profile/profileSlice";
import ProfileSide from "../components/common/ProfileSide";
import EditProfileContent from "../components/edit/EditProfileContent";
import {useNavigate} from "react-router";

const EditProfile = () => {

    const profile = useAppSelector(state=>state.login.profile);

    useScrollTop();

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(()=>{
        dispatch(fetchProfileData('edit'));
    },[]);

    useEffect(()=>{
        if(+profile.user_id === 0){
            navigate('/');
        }
    },[profile]);

    return (
        <main className={"page"}>
            <div className={"profile_content w-wrap"}>
                <ProfileSide />
                <div className={"profile_main"}>
                    <EditProfileContent />
                </div>
            </div>
        </main>
    )
}

export default EditProfile;